const applicationDomainMap = {
  wbm: 'xing.com',
  kun: 'kununu.com',
  leb: 'lebenslauf.com',
  onf_one: 'onlyfy.io',
};

const getApplicationByDomain = secondLevelDomain => {
  const matchedEntry = Object.entries(applicationDomainMap).find(
    ([app, domain]) => domain === secondLevelDomain
  );
  return matchedEntry ? matchedEntry[0] : '';
};

export default getApplicationByDomain;
